import React from "react";
const activityTabs = [
  { title: "Music" },
  { title: "Art & Craft" },
  { title: "P. Development" },
  { title: "Sports" },
  { title: "Playground" },
];
const features = [
  "Qualified Teacher",
  "Love & Care",
  "Delicious Food",
  "Strategic Location",
  "Active Learning",
  "Transportation",
];
const SchoolActivities = () => {
  return (
    <section className="relative py-16 px-4 md:px-8 bg-gradient-to-br from-orange-50 via-red-50 to-pink-50 w-full overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-orange-200/30 rounded-full blur-3xl -translate-x-48 -translate-y-48"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-200/30 rounded-full blur-3xl translate-x-48 translate-y-48"></div>
      <div className="relative w-full max-w-full mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex px-5 py-2 bg-white rounded-full shadow-md mb-4">
            <span className="text-sm font-semibold text-red-600">
              Creative Learning
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900">
            Our{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Activities
            </span>
          </h2>
          <p className="text-gray-600 mt-3 max-w-2xl mx-auto text-sm md:text-base">
            A joyful learning environment where children explore creativity,
            confidence, discipline and teamwork.
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {activityTabs.map((item, index) => (
            <div
              key={index}
              className="group bg-white px-5 py-2 rounded-full shadow-md border border-orange-100 hover:bg-gradient-to-r hover:from-red-600 hover:to-orange-500 hover:text-white hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <span className="text-xs md:text-sm font-semibold group-hover:text-white">
                {item.title}
              </span>
            </div>
          ))}
        </div>
        <div className="w-full bg-white rounded-2xl shadow-xl overflow-hidden border border-orange-100 hover:shadow-2xl transition-all duration-500">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative h-80 lg:h-full min-h-[400px]">
              <img
                src="image2.png"
                alt="School Activities"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-red-600/30 to-orange-500/20"></div>
              <div className="absolute bottom-5 left-5 right-5 bg-white/95 backdrop-blur-md rounded-xl p-4 shadow-lg">
                <h3 className="text-lg font-bold text-gray-900 mb-1">
                  Music, Dance & Theatre
                </h3>
                <p className="text-gray-600 text-xs">
                  Helping children express themselves creatively
                </p>
              </div>
            </div>
            <div className="p-6 md:p-8">
              <span className="inline-block px-3 py-1 text-xs font-bold text-red-600 bg-red-100 rounded-full mb-3">
                Why Choose Us
              </span>
              <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 leading-tight mb-3">
                Learning Through{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-orange-500">
                  Creativity & Expression
                </span>
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">
                Music and dance help children express themselves creatively and build self-confidence.
              </p>
              <p className="text-gray-600 text-sm leading-relaxed mb-5">
                These subjects help students understand themselves better and improve their communication skills.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-6">
                {features.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-2 bg-gradient-to-r from-orange-50 to-red-50 rounded-lg p-2 hover:shadow-md transition-all duration-300"
                  >
                    <div className="w-1.5 h-1.5 rounded-full bg-gradient-to-r from-red-600 to-orange-500"></div>
                    <span className="text-xs md:text-sm font-semibold text-gray-700">
                      {item}
                    </span>
                  </div>
                ))}
              </div>
              <button className="w-full bg-gradient-to-r from-red-600 to-orange-500 text-white font-semibold text-sm py-2.5 px-6 rounded-lg hover:shadow-lg hover:scale-105 transition-all duration-300">
                Explore More Activities
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default SchoolActivities;